import { ApiConnector } from './api.connector';

export interface IOnlineTranslationsResponse {
  lang: string;
  date: string;
  data: Record<string, string>;
}

class TranslationsApi extends ApiConnector {
  async getOnlineTranslations(
    language: string
  ): Promise<IOnlineTranslationsResponse> {
    return this.call<{ lang: string }, IOnlineTranslationsResponse>({
      path: 'translations/online',
      method: 'get',
      params: { lang: language }
    });
  }
}

export const translationsApi = new TranslationsApi();
